import * as React from 'react';

import { PostingDrawer } from './components/PostingDrawer';
import { PostingModal } from './components/PostingModal';

export const PostingExperience: React.FC<{
  isModalOpen: boolean;
  onModalClose: () => void;
  isDrawerOpen: boolean;
  onDrawerClose: () => void;
  tabIndex: number;
  onTabChange: React.Dispatch<React.SetStateAction<number>>;
  createPost: () => void;
  createPoll: () => void;
  createQuestion: () => void;
  createArticle: () => void;
  options?: {
    group?: { _id: string };
    organization?: { _id: string };
    showFixedGroupName?: boolean;
    postId?: string;
    tags?: { _id: string; name: string }[];
    defaultIsSponsoredPost?: boolean;
  };
}> = (props) => {
  return (
    <>
      <PostingModal {...props} />
      <PostingDrawer {...props} />
    </>
  );
};
